export type NestedObject = Record<string, unknown>

export const mergeNestedObjectsStructure: (
    objects: NestedObject[]
) => NestedObject = (objects) => {
    const isObject = (value: unknown): value is NestedObject =>
        value !== null && typeof value === 'object' && !Array.isArray(value)

    return objects.reduce((acc, obj) => {
        Object.entries(obj).forEach(([key, value]) => {
            // If the value is an object, we recursively merge it
            if (isObject(value)) {
                acc[key] = isObject(acc[key])
                    ? mergeNestedObjectsStructure([acc[key], value]) // Merge if it's an object
                    : value // If it's not an object, assign the current value
            } else {
                // Directly assign the value if it's not an object
                acc[key] = value
            }
        })
        return acc
    }, {}) // Initialize as NestedObject
}
